// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5789":"15cd02a8","8629":"63e084d2"}[chunkId] + ".chunk.css";
};